import {Injectable} from '@angular/core';
import {AdminUser} from "../dto/AdminUser";
import {Setting} from "../dto/Setting";



@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  public user:AdminUser=new  AdminUser();
  public progressBar: boolean = false;
  public doc:string="";
  public page:string="";
  public  hidePostMain:boolean=false;
  public loadedMain=false;
  constructor() {

  }


  setUser(user:AdminUser){
    localStorage.setItem("user",JSON.stringify(user));
  }
  getUser():AdminUser{
    return JSON.parse(localStorage.getItem("user")||"");
  }

  getPermissions():Set<String>{
    var  perm:Set<String> = new Set<String>();
    var adus:AdminUser = JSON.parse(localStorage.getItem("user")||"");
    if(adus!=null) {
      for (let rol of adus.rols) {
        for (let permission of rol.permissions) {
          perm.add(permission.name);
        }
      }
    }
    return perm;
  }


  setCluster(str:string){
    localStorage.setItem("cluster",str);
  }
  getCluster():string{
    return localStorage.getItem("cluster") || ""  ;
  }

  setMainData(data:Map<string,Setting>){
    localStorage.setItem("mainData",JSON.stringify(data));
  }
  getMainData():Map<string,Setting>{
    return  JSON.parse(localStorage.getItem("mainData"));
  }


}
